<template>
    <!--页面主体-->
    <div class="erji_ynjc">
        <div class="infoBox_ynjc">
            <div class="news_title_ynjc">
                <span class="news_title_ico_ynjc policys_title_ico"></span>
                <span class="news_title_text_ynjc">{{pageName}}</span>
            </div>
            <div class="notices_main_ynjc">
                <ul>
                    <li v-for="item in newsList" :key="item.id">
                        <span class="notices_main_li_ico2_ynjc"></span>
                        <router-link :to="{ path: 'newsInfo', query: { id: item.id }}" target="_blank" :title="item.newsTitle">{{item.newsTitle}}</router-link>
                        <span class="notices_main_li_time_ynjc">{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
                    </li>
                </ul>
                <div class="page_ynjc">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageNum"
                            :page-size="pageSize"
                            layout="prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {listNews} from '../api/api';
    export default {
        props: {
            settings: {
                type: Object,
                default: function () {
                    return {
                        parentTagId:this.$route.query.parentTagId,
                        tagId:this.$route.query.tagId,
                        consultId: 52,
                        publishState: 0,
                        publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                        'displayPositionIds': [1, 3],
                        'notProjectIds': [8, 9],
                        'projectIdsC': this.conversionProjectIdsC,
                        'orderWeight': true,
                        orderPublishTime: true,
                        pageNum: this.pageNum,
                        pageSize: this.pageSize
                    }
                },
                validator: function () {
                    let isValidator = true;
                    return isValidator
                }
            }
        },
        data () {
            return {
                newsList: [],
                pageName: this.settings.consultName,
                pageNum: 1,
                pageSize: 10,
                total: 0
            }
        },
        mounted () {
            this.initD();
        },
        computed: {
            conversionProjectIdsC() {
                let projectIdsC = this.$route.query.projectIdsC;
                if(projectIdsC&&projectIdsC.length>0){
                    if(projectIdsC instanceof Array){
                        return projectIdsC;
                    }else{
                        return new Array(this.$route.query.projectIdsC);
                    }
                }else{
                    return []
                }
            }
        },
        methods: {
            initD(){
                listNews(this.settings).then((response) => {
                    this.newsList = response.data.data.list;
                    this.total = response.data.data.total;
                    console.log(this.total)
                })
            },
            handleCurrentChange(val) {
                this.settings.pageNum = val;
                this.initD();
            },
            handleSizeChange(val) {
                this.settings.pageSize = val;
                this.initD();
            },
        }
    }
</script>

<style scoped>

</style>

